import BaseService from "./BaseService";

class PaymentFormService {
  static async GetPaymentForms(tennantId, token) {
    try {
      return await BaseService.get("paymentforms", token, { tennantId, pageSize: 100, page: 1 });
    } catch (error) {
      console.error("There was an error fetching the payment forms!", error);
      throw error;
    }
  }
}

export default PaymentFormService;
